import {Box, BoxProps, Popover, PopoverProps} from '@material-ui/core';
import cn from 'classnames';
import React, {useCallback, useState} from 'react';
import './ImageCard.scss';
import {ImageCard, ImageMetadata} from './ImageCard';
import {ImageProps} from 'material-ui-image/lib/components/Image/Image';
import {useIntl} from 'react-intl';
import fileSize from 'filesize';

export type ImageCardProps = BoxProps & {
  className?: string;
  title?: string;
  imageL: (w?: number, h?: number) => string;
  imageR: (w?: number, h?: number) => string;
  width?: number;
  height?: number;
  showImageMetadata?: boolean;
};

export const DoubleImageCard = ({
  className,
  imageL,
  imageR,
  width,
  height,
  showImageMetadata,
  ...rest
}: ImageCardProps) => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = React.useState<PopoverProps['anchorEl']>(null);
  const onOpen: ImageProps['onClick'] = event => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const onClose: ImageProps['onClick'] = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };

  const [imageMetadata, setImageMetadata] = useState<ImageMetadata>();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getImageL = useCallback(imageL, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getImageR = useCallback(imageR, []);

  var lw = width * 3;
  var lh = height * 3;

  return (
    <Box
      className={cn('image-card-horizontal', className)}
      {...rest}
      style={{width: width * 2}}
      onClick={onOpen}
    >
      <Box className="image-card-horizontal_containerL">
        <ImageCard
          imageFunc={getImageL}
          width={width}
          height={height}
          isPopup={false}
          saveImageMetadata={metadata => setImageMetadata(metadata)}
        />
      </Box>
      <Box className="image-card-horizontal_containerR">
        <ImageCard imageFunc={getImageR} width={width} height={height} isPopup={false} />
      </Box>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        disableScrollLock
        PaperProps={{
          style: {
            width: lw * 2,
            height: lh + 70,
            overflow: 'hidden',
          },
        }}
      >
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <Box sx={{height: lh}}>
            <Box sx={{width: lw, height: lh, position: 'absolute'}}>
              <ImageCard imageFunc={getImageL} width={lw} height={lh} isPopup={false} />
            </Box>
            <Box sx={{width: lw, height: lh, left: lw, position: 'absolute'}}>
              <ImageCard imageFunc={getImageR} width={lw} height={lh} isPopup={false} />
            </Box>
          </Box>
          {showImageMetadata && imageMetadata && (
            <Box display="flex" className="data-viewer-tooltip__metadata">
              <Box display="flex" flexDirection="column">
                <div className="data-viewer-tooltip__filename">
                  {imageMetadata?.filename}
                </div>
              </Box>
              <Box display="flex">
                <div className="data-viewer-tooltip__size">
                  File size: {fileSize(imageMetadata?.fileSize)}
                </div>
              </Box>
              <Box display="flex">
                <div className="data-viewer-tooltip__size">
                  {intl.formatMessage(
                    {id: 'dataViewer.dimensions.size'},
                    {
                      width: imageMetadata?.width,
                      height: imageMetadata?.height,
                    }
                  )}
                </div>
              </Box>
            </Box>
          )}
        </Box>
      </Popover>
    </Box>
  );
};
